var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMaintenance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-maintenance",
    transform: "translate(-1657 -250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2634",
    "data-name": "Rectangle 2634",
    transform: "translate(1657 250)",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 14,
    height: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2952",
    "data-name": "Path 2952",
    d: "M12.62,10.318l4.223,4.193-2.49,2.46L10.16,12.778v-.69l1.77-1.77h.69m.682-1.9-.727-.72L8.983,11.3v1.478L4.76,17,2.3,14.51l4.192-4.193H7.97l.585-.585L5.675,6.845H4.7L2.592,4.715,4.557,2.75l2.1,2.1v.982l2.918,2.88L11.57,6.717l-.72-.757.975-.983H9.83L9.342,4.49,11.825,2l.495.5v2L13.3,3.5l2.46,2.46a2.123,2.123,0,0,1,0,2.985L14.285,7.438Z",
    transform: "translate(1654.929 248)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaintenance);
export default __webpack_public_path__ + "static/media/icon-maintenance.0c7d4450536d3f9c06360bc9f68f197f.svg";
export { ForwardRef as ReactComponent };